// extracted by mini-css-extract-plugin
module.exports = {"starGroup":"StarRating_starGroup__6JM8t"};